module.exports = __webpack_public_path__ + "static/mockupPhoneNew-7be680ac14e4c1511efe48e2759b12c5.png";